export const selectableLayers = {
  location: 'locations',
  passlines: 'passlines',
  locationIds: 'locationIds',
  municipalities: 'municipalities'
};
